import {h, Fragment} from "preact"
import { useAppState, useFacets, useProductFilters } from "@nosto/preact"
import { sortSizeData } from "../helpers"

import CheckboxFacet from "./CheckboxFacet"
import BoxedFacet from "./BoxedFacet"
import ColorFacet from "./ColorFacet"
import RangeFacet from "./RangeFacet"

export default function SideBar({ sidebarOpen, toggleSidebar }) {
    const { response } = useAppState();
    const { facets } = useFacets();
    const { filters, removeAll } = useProductFilters();
    const docCount = response.products?.total ?? 0

    return facets?.length > 0 ? (
        <>
            <aside
                className="fixed flex flex-col"
                id="ns-sidebar"
                aria-expanded={sidebarOpen}
                aria-label="Filter options"
            >
                {/* HEADER */}
                <div class="ns-sidebar__header">
                    <div className="flex items-center gap-2">
                        <span className="flex-1 font-instrumentRegular text-base m-0">
                            Filters
                        </span>
                        <button
                            className="text-black lg:text-grey-5 w-6 lg:w-4 h-6 lg:h-4 p-0.5"
                            type="button"
                            aria-label="Close filter list"
                            aria-controls="ns-sidebar"
                            onClick={toggleSidebar}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true" focusable="false" class="icon icon-close !w-full !h-full" fill="none" viewBox="0 0 18 17">
                                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                            </svg>
                        </button>
                    </div>
                </div>
                
                <div class="ns-sidebar__body p-0 pt-8">
                    <div className="flex flex-col h-full">
                        {/* BODY */}
                        <div className="flex-1 flex flex-col gap-10 overflow-auto px-6 lg:px-[30px] pb-6 list-unstyled p-0 m-0">
                            {facets?.map(facet => {
                                if(facet.type === 'terms') {
                                    if(facet.name === 'Size') {
                                        sortSizeData(facet.data);
                                        return (<BoxedFacet facet={facet} key={facet.field} />)
                                    } else if (facet.name === 'Color' || facet.name === 'Color 2') {
                                        return (<ColorFacet facet={facet} key={facet.field} />)
                                    } else {
                                        return (<CheckboxFacet facet={facet} key={facet.field} />)
                                    }
                                } else if (facet.type === 'stats') {
                                    return (<RangeFacet facet={facet} key={facet.field} />)
                                } else {
                                    return null;
                                }
                            })}
                        </div>
                        {/* FOOTER */}
                        <div class="ns-sidebar__footer p-2 border-t border-grey-2 lg:border-0">
                            <div className="grid grid-cols-2 gap-2">
                                <button
                                    className="button button--secondary-dark !rounded-lg !border-grey-5"
                                    type="button"
                                    disabled={filters.length < 1}
                                    aria-label="Remove all filters"
                                    onClick={removeAll}
                                >
                                    Clear {filters.length > 0 ? `(${filters.length})` : ''}
                                </button>
                                <button
                                    className="button button--primary-dark !rounded-lg"
                                    type="button"
                                    aria-label="Apply selected filters"
                                    onClick={toggleSidebar}
                                >
                                    Show ({docCount})
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>

            {/* backdrop */}
            <div
                className="ns-sidebar__backdrop fixed"
                aria-label="Close filters list"
                aria-controls="ns-sidebar"
                role="button"
                tabIndex="0"
                onClick={toggleSidebar}
            ></div>
        </>
    ) : ( null )
}
